import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleDown } from '@fortawesome/pro-solid-svg-icons';

import { Panel, Collapse } from 'react-bootstrap';

export default class CollapsibleSample extends React.Component {

  state = {
    open: false
  }

  toggleCollapse = () => this.setState(({ open }) => ({ open: !open }));

  render() {
    return (
      <Panel.Body className="p-5">
        <div className="row-eq-height clickable align-top" onClick={this.toggleCollapse}>
          <FontAwesomeIcon className="right-buffer-md" icon={this.state.open ? faAngleDown : faAngleRight} size="2x"/>
          <h2 className="mt-0">
            Collapsible Component Header
          </h2>
        </div>
        <Collapse in={this.state.open}>
          <div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
              ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum.
            </p>
          </div>
        </Collapse>
      </Panel.Body>
    );
  }
}
